import {APP_INITIALIZER, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {TopicRoutingModule} from './topic-routing.module';
import {FormsModule} from '@angular/forms';
import {DndModule} from 'ng2-dnd';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {SharedModule} from '../shared/shared.module';
import {TopicService} from './topic.service';
import {LanguageProvider} from './language.provider';
import {ExercisesComponent} from './exercises/exercises.component';
import {TopicComponent} from './topic/topic.component';
import { SymbolsEncodingDefectComponent } from './symbols-encoding-defect/symbols-encoding-defect.component';
import { DefectEncodingComponent } from './defect-encoding/defect-encoding.component';
import { SymbolsEncodingEqualOrNotComponent } from './symbols-encoding-equal-or-not/symbols-encoding-equal-or-not.component';
import { CountDifferencesComponent } from './count-differences/count-differences.component';
import { SymbolsEncodingRandomComponent } from './symbols-encoding-random/symbols-encoding-random.component';
import { BuildMessageComponent } from './build-message/build-message.component';
import { RepairEncodingComponent } from './repair-encoding/repair-encoding.component';
import { BuildMessageReadMessageTwoPlayerComponent } from './build-message-read-message-two-player/build-message-read-message-two-player.component';
import { ReadMessageComponent } from './read-message/read-message.component';
import { BuildMessageContentComponent } from './build-message-content/build-message-content.component';
import { ReadMessageContentComponent } from './read-message-content/read-message-content.component';
import { GenerateEncodingBuildMessageComponent } from './generate-encoding-build-message/generate-encoding-build-message.component';
import { GenerateEncodingComponent } from './generate-encoding/generate-encoding.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxChartsModule,
    SharedModule
  ], providers: [TopicService,
    LanguageProvider,
    {provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true}],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    SymbolsEncodingDefectComponent,
    DefectEncodingComponent,
    SymbolsEncodingEqualOrNotComponent,
    CountDifferencesComponent,
    SymbolsEncodingRandomComponent,
    BuildMessageComponent,
    RepairEncodingComponent,
    BuildMessageReadMessageTwoPlayerComponent,
    ReadMessageComponent,
    BuildMessageContentComponent,
    ReadMessageContentComponent,
    GenerateEncodingBuildMessageComponent,
    GenerateEncodingComponent,
  ]
})
export class EncodingModule { }
export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}
